module.exports = __webpack_public_path__ + "static/img/news3-cover.635db77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/news3-cover.jpg
// module id = pc5s
// module chunks = 0